import { useState } from "react";
import { atom, useAtom } from "jotai";
import { useNavigate } from "react-router-dom";
import HardwareDialog from "./hardware_dialog";
import AttentionDialog from "./attention_dialog";
import { useLocation } from 'react-router-dom';
import { useForm } from "react-hook-form";
import { getModelList, getOsList, getSwList, getHwList } from '../../api/api';
import Maintenance from "./maintenance";

const UNSELECT = "(未選択)";
const OTHER_HW = "(未選択)";
const OTHER_OS = "(未選択)";

const endUserAtom = atom();
const hwNumAtom = atom();
const osVerAtom = atom();
const operationTypeAtom = atom();
const reapearanceAtom = atom();
const titleAtom = atom();
const questionAtom = atom();
const attachedFileAtom = atom();
const mailAtom = atom();
const checkBoxAtom = atom(false);
const modelAtom = atom(UNSELECT)
const oSAtom = atom(UNSELECT)
const hardware1Atom = atom(OTHER_HW)
const hardware2Atom = atom(OTHER_HW)
const softwareAtom = atom()
const softwareNumAtom = atom()
const openModelDialogAtom = atom({ show: false, dialogId: 0 });
const openOsDialogAtom = atom({ show: false, dialogId: 0 });
const openHwDialogAtom = atom({ show: false, dialogId: 0 });
const openSwDialogAtom = atom({ show: false, dialogId: 0 });
const openAttentionDialogAtom = atom({ show: false, dialogId: 0 });
const modelDataAtom = atom();
const osDataAtom = atom();
const hwDataAtom = atom();
const swDataAtom = atom();
const dialogValueAtom = atom([]);
const hWListAtom = atom([]);
const sWListAtom = atom([]);
const emailListAtom = atom([]);

const buttonStyle = {
    border: "none",
    textAlign: "left",
    color: "#069",
    textDecoration: "underline",
    cursor: "pointer"
};


function MainComponent({ handleLoading }) {

    document.title = "お問い合わせ(新規)| ファーストコンタクトセンター";
    const imageUrlPopUp = require("../../images/popup.png")
    const navigate = useNavigate();
    const location = useLocation();
    const [hWList, setHWList] = useAtom(hWListAtom);
    const [hWSize, sethWSize] = useState(hWList.length + 1);
    const [sWList, setSWList] = useAtom(sWListAtom)
    const [sWSize, setSWSize] = useState(sWList.length + 1)
    const [emailList, setEmailList] = useAtom(emailListAtom)
    const [emailSize, setEmailSize] = useState(emailList.length + 1)
    const [endUser, setEndUser] = useAtom(endUserAtom);
    const [hwNum, setHwNum] = useAtom(hwNumAtom);
    const [osVer, setOsVer] = useAtom(osVerAtom);
    const [operationType, setOperationType] = useAtom(operationTypeAtom);
    const [reapearance, setReapearance] = useAtom(reapearanceAtom);
    const [title, setTitle] = useAtom(titleAtom);
    const [question, setQuestion] = useAtom(questionAtom);
    const [attachedFile, setAttachedFile] = useAtom(attachedFileAtom);
    const [mainMail, setMainMail] = useAtom(mailAtom);
    const [checkBox, setCheckBox] = useAtom(checkBoxAtom);
    const [openHwDialog, setOpenHwDialog] = useAtom(openHwDialogAtom);
    const [openSwDialog, setOpenSwDialog] = useAtom(openSwDialogAtom);
    const [openModelDialog, setOpenModelDialog] = useAtom(openModelDialogAtom);
    const [openOsDialog, setOpenOsDialog] = useAtom(openOsDialogAtom);
    const [openAttentionDialog, setOpenAttentionDialog] = useAtom(openAttentionDialogAtom);
    const [dialogValue, setDialogValue] = useAtom(dialogValueAtom);
    const [model, setModel] = useAtom(modelAtom);
    const [os, setOs] = useAtom(oSAtom);
    const [hardware1, setHardware1] = useAtom(hardware1Atom);
    const [hardware2, setHardware2] = useAtom(hardware2Atom);
    const [software, setSoftware] = useAtom(softwareAtom);
    const [modelData, setModelData] = useAtom(modelDataAtom);
    const [osData, setOsData] = useAtom(osDataAtom);
    const [hwData, setHwData] = useAtom(hwDataAtom);
    const [swData, setSwData] = useAtom(swDataAtom);
    const [softwareNum, setSoftwareNum] = useAtom(softwareNumAtom);
    const [isProductionListExist, setIsProductionListExist] = useState(localStorage.getItem("productionLists") ? true : false);
    const { register, formState: { errors }, handleSubmit, clearErrors, reset, setValue } = useForm({ shouldFocusError: false });
    const onSubmit = (data) => {
        buttonRegist();
    }
    const valueCheck = ["", undefined, null, false, "[]", "{}"];
    async function getProdutionList() {
        let productionListsStr = localStorage.getItem("productionLists");
        if (productionListsStr) {
            const productionList = JSON.parse(productionListsStr);
            return productionList;
        }
        const modelList = await getModelList((data) => {
            if (data === false) {
                alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。");
                navigate("/fcc_login");
            }
        });
        const osList = await getOsList((data) => {
            if (data === false) {
                alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。");
                navigate("/fcc_login");
            }
        });
        const hwList = await getHwList((data) => {
            if (data === false) {
                alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。");
                navigate("/fcc_login");
            }
        });
        const swList = await getSwList((data) => {
            if (data === false) {
                alert("現在サーバーが込み合っているか、または、システムメンテナンス中です。時間を置いて再試行してください。");
                navigate("/fcc_login");
            }
        });
        const productionList = {
            modelList,
            osList,
            hwList,
            swList
        }
        localStorage.setItem("productionLists", JSON.stringify(productionList));
        return productionList;
    }


    let productionListsStr = localStorage.getItem("productionLists");
    if (productionListsStr) {
        let lists = JSON.parse(productionListsStr);
        if (modelData === undefined) {
            setModelData(lists.modelList);
        }
        if (osData === undefined) {
            setOsData(lists.osList);
        }
        if (hwData === undefined) {
            setHwData(lists.hwList);
        }
        if (swData === undefined) {
            setSwData(lists.swList);
        }
    }

    if (isProductionListExist === false) {
        handleLoading(true);
        getProdutionList().then((lists) => {
            setModelData(lists.modelList);
            setOsData(lists.osList);
            setHwData(lists.hwList);
            setSwData(lists.swList);
            handleLoading(false);
        });
        setIsProductionListExist(true);
    }
    if (reapearance === undefined) {
        setReapearance("4");
    }
    if (mainMail === undefined) {
        setMainMail(localStorage.getItem('email'));
    }
    if (!location.state) {
        location.state = { page: false };
    }
    function initInput() {
        setEndUser(location.state.endUser);
        setModel(UNSELECT);
        setValue("model", "");
        setOs(UNSELECT);
        setValue("os", "");
        setHwNum(location.state.hwNum);
        setOsVer(location.state.osVer);
        setReapearance(location.state.reapearance ? location.state.reapearance : "4");
        setOperationType(location.state.operationType);
        setValue("operationType", location.state.operationType);
        setAttachedFile(location.state.attachedFile);
        setValue("attached_file", location.state.attachedFile);
        setTitle(location.state.title);
        setValue("title", location.state.title);
        setQuestion(location.state.question);
        setValue("question", location.state.question);
        setMainMail(localStorage.getItem('email'));
        setEmailList(location.state.emailList);
        setEmailSize(location.state.emailSize);
        setHWList(location.state.hWList);
        sethWSize(parseInt(location.state.hWSize));
        setSWList(location.state.sWList);
        setSWSize(parseInt(location.state.sWSize));
        setDialogValue(location.state.dialogValue);
        setCheckBox(false);
        if (location.state.dialogValue !== []) {
            for (let i in location.state.dialogValue) {
                if (location.state.dialogValue[i].dialogId === "hwNameText0") {

                    setModel(location.state.dialogValue[i].value)
                    setValue("model", location.state.dialogValue[i].value)

                }
                if (location.state.dialogValue[i].dialogId === "swNameText0") {
                    setOs(location.state.dialogValue[i].value)
                    setValue("os", location.state.dialogValue[i].value)
                }
                if (location.state.dialogValue[i].dialogId === "hwNameText1") {
                    setHardware1(location.state.dialogValue[i].value)
                    setValue("hwNameText1", location.state.dialogValue[i].value);

                }
                if (location.state.dialogValue[i].dialogId === "hwNameText2") {
                    setHardware2(location.state.dialogValue[i].value)
                    setValue("hwNameText2", location.state.dialogValue[i].value);

                }
                if (location.state.dialogValue[i].dialogId === "swNameText1") {
                    setSoftware(location.state.dialogValue[i].value);
                    setValue("swNameText1", location.state.dialogValue[i].value);
                    setSoftwareNum(location.state.softwareNum);
                }
            }
        }
        if (valueCheck.includes(JSON.stringify(location.state.dialogValue)) === true) {
            setModel(UNSELECT)
            setValue("model", "")
            setOs(UNSELECT)
            setValue("os", "")
            setHardware1(OTHER_HW)
            setValue("hwNameText1", "");
            setHardware2(OTHER_HW)
            setValue("hwNameText2", "");
            setSoftware(OTHER_OS)
            setValue("swNameText1", "");
            setSoftwareNum("")
        }
        location.state.page = false
    }
    if (location.state.page === true) {
        clearErrors();
        initInput();
    }
    if (location.state.emailReset === true) {
        reset({
            mail_adr1: "",
            mail_adr2: "",
            mail_adr3: "",
            mail_adr4: ""
        });
        location.state.emailReset = false;
    }

    const handleMouseEnter = (event) => {
        event.target.style.textDecoration = 'none';
    };

    const handleMouseLeave = (event) => {
        event.target.style.textDecoration = 'underline';
    };

    const handleClose = (newValue, id) => {
        setOpenHwDialog({ show: false });
        setOpenSwDialog({ show: false });
        setOpenOsDialog({ show: false });
        setOpenModelDialog({ show: false });
        setOpenAttentionDialog({ show: false });
        if (id) {
            let result = dialogValue.find(({ dialogId }) => dialogId === id)
            if (JSON.stringify(result) === undefined) {
                if (id === "hwNameText0") {
                    setModel(newValue ? newValue : "");
                    setValue("model", newValue ? newValue : "");
                }
                if (id === "swNameText0") {
                    setOs(newValue ? newValue : UNSELECT);
                    setValue("os", newValue ? newValue : "")
                }
                if (id === "hwNameText1" || id === "hwNameText2" || id === "swNameText1") {
                    document.getElementById(id).innerHTML = id ? newValue : UNSELECT;
                    setValue(`${id}`, newValue ? newValue : UNSELECT);
                }
                return setDialogValue([...dialogValue, { dialogId: id, value: newValue }])
            }
            if (JSON.stringify(result)) {
                let resultId = JSON.stringify(result.dialogId)
                resultId = resultId.substring(1, resultId.length - 1)
                if (resultId === id) {
                    if (id === "hwNameText0") {
                        setModel(newValue ? newValue : "");
                        setValue("model", newValue ? newValue : "");
                    }
                    if (id === "swNameText0") {
                        setOs(newValue ? newValue : UNSELECT);
                        setValue("os", newValue ? newValue : "");
                    }
                    if (id === "hwNameText1" || id === "hwNameText2" || id === "swNameText1") {
                        document.getElementById(id).innerHTML = id ? newValue : UNSELECT;
                        setValue(`${id}`, newValue ? newValue : UNSELECT);
                    }
                    setDialogValue(dialogValue.map(el =>
                        el.dialogId === resultId ? { ...el, value: newValue } : el
                    ));

                }
                if ((resultId !== id)) {
                    document.getElementById(id).innerHTML = id ? newValue : UNSELECT;
                    return setDialogValue([...dialogValue, { dialogId: id, value: newValue }])
                }
            }

        }
    };

    const handleValue = (id) => {
        if (id != null) {
            let result = dialogValue.find(({ dialogId }) => dialogId === id)
            if (result !== undefined) {
                let value = JSON.stringify(result.value);
                value = value.substring(1, value.length - 1)
                return value
            }
            return ""
        }
        return
    }

    const handleEndUserChange = (event) => {
        setEndUser(event.target.value);
        clearErrors();
    }

    const handleHwNumChange = (event) => {
        setHwNum(event.target.value);
        clearErrors();
    }

    const handleOsVerChange = (event) => {
        setOsVer(event.target.value);
        clearErrors();
    }

    const handleHardWare = (event) => {
        clearErrors();
        let newHwList = hWList.map((item) => {
            if (item.size === parseInt(event.target.name)) {
                return { ...item, num: event.target.value };
            }
            return item;
        });
        setHWList(newHwList);
    }

    const handleSoftWare = (event) => {
        setSoftwareNum(event.target.value);
        clearErrors();
    }

    const handleOperationTypeChange = (event) => {
        setOperationType(event.target.value);
        setValue("operationType", event.target.value)
        clearErrors();
    }

    const handleReapearanceChange = (event) => {
        setReapearance(event.target.value);
        clearErrors();
    }

    const handleTitleChange = (event) => {
        setTitle(event.target.value);
        setValue("title", event.target.value);
        clearErrors();
    }

    const handleQuestionChange = (event) => {
        setQuestion(event.target.value);
        setValue("question", event.target.value);
        clearErrors();
    }

    const handleAttachedFileChange = (event) => {
        setAttachedFile(event.target.value);
        setValue("attached_file", event.target.value);
        clearErrors();
    }

    const handleCheckBoxChange = (event) => {
        setCheckBox(event.target.checked);
        clearErrors();
    }

    const handleMailChange = (event) => {
        let newEmailList = emailList.map((item) => {
            if (item.emailId === event.target.id) {
                setValue(event.target.id, event.target.value);
                return { ...item, email: event.target.value };
            }

            return item;
        });
        clearErrors();
        setEmailList(newEmailList);
    }
    const handleMailConfirmChange = (event) => {
        let newEmailList = emailList.map((item) => {
            if (item.emailConfirmId === event.target.id) {
                setValue(event.target.id, event.target.value);
                return { ...item, emailConfirm: event.target.value };
            }
            return item;
        });
        clearErrors();
        setEmailList(newEmailList);
    }
    const addHw = () => {
        clearErrors();
        sethWSize(hWSize => hWSize + 1);
        setHWList([...hWList, { size: hWSize, num: "" }]);
    }
    const delHw = () => {
        clearErrors();
        const list = [...hWList];
        reset({
            deletedHardware: ""
        })
        list.pop();
        setHWList(list);
        sethWSize(hWSize => hWSize - 1);
        if (hWSize === 3) {
            let newDialogvalue = dialogValue.filter((el) => el.dialogId !== "hwNameText2");
            setHardware2(OTHER_HW);
            return setDialogValue(newDialogvalue);
        }
        if (hWSize === 2) {
            setHardware1(OTHER_HW)
            let newDialogvalue = dialogValue.filter((el) => el.dialogId !== "hwNameText1");
            return setDialogValue(newDialogvalue);
        }
    }

    const addSw = () => {
        clearErrors();
        setSWSize(sWSize => sWSize + 1);
        setSWList([...sWList, { size: sWSize }]);


    }

    const delSw = (sWSize) => {
        clearErrors();
        const list = [...sWList];
        reset({
            deletedSoftware: ""
        })
        list.pop();
        setSWList(list);
        setSWSize(sWSize => sWSize - 1);
        if (sWSize !== 1) {
            let newDialogvalue = dialogValue.filter((el) => el.dialogId !== "swNameText1");
            setSoftwareNum("");
            setSoftware("");
            return setDialogValue(newDialogvalue);
        }
    }

    const addEmail = () => {

        setEmailSize(emailSize => emailSize + 1);
        setEmailList([...emailList, { size: emailSize, email: "", emailConfirm: "", emailId: `mail_adr${emailSize}`, emailConfirmId: `mail_adr_chk_${emailSize}` }]);
        clearErrors();
    }

    const delEmail = (emailSize) => {

        const list = [...emailList];
        reset({
            deletedEmail: ""
        })
        list.pop();
        setEmailList(list);
        setEmailSize(emailSize => emailSize - 1);
        clearErrors();
    }

    const checkErrorIsExist = () => {
        if (errors.model?.message) {
            return true;
        }
        if (errors.os?.message) {
            return true;
        }
        if (errors.operationType?.message) {
            return true;
        }
        if (errors.hwNameText1?.message) {
            return true;
        }
        if (errors.hwNameText2?.message) {
            return true;
        }
        if (errors.swNameText1?.message) {
            return true;
        }
        if (errors.title?.message) {
            return true;
        }
        if (errors.question?.message) {
            return true;
        }
        if (errors.attached_file?.message) {
            return true;
        }
        if (errors.mail_adr1?.message || errors.mail_adr2?.message || errors.mail_adr3?.message || errors.mail_adr4?.message) {
            return true;
        }
        return false;
    }

    const checkErrors = (errors) => {
        let mailErrors = [];
        let formErrors = [];
        let inputErrors = [];

        if (errors.model?.message) {
            alert(errors.model?.message);
            clearErrors();
            return;
        }
        if (errors.os?.message) {
            alert(errors.os?.message);
            clearErrors();
            return;
        }
        if (errors.operationType?.message) {
            alert(errors.operationType?.message);
            clearErrors();
            return;
        }
        if (errors.hwNameText1?.message) {
            alert(errors.hwNameText1?.message);
            clearErrors();
            return;
        }
        if (errors.hwNameText2?.message) {
            alert(errors.hwNameText2?.message);
            clearErrors();
            return;
        }
        if (errors.swNameText1?.message) {
            alert(errors.swNameText1?.message);
            clearErrors();
            return;
        }
        if (errors.title?.message) {
            alert(errors.title?.message);
            clearErrors();
            return;
        }
        if (errors.question?.message) {
            alert(errors.question?.message);
            clearErrors();
            return;
        }
        if (errors.attached_file?.message) {
            alert(errors.attached_file?.message);
            clearErrors();
            return;
        }
        if (errors.mail_adr1?.message) {
            mailErrors[1] = errors.mail_adr1?.message;
        }
        if (errors.mail_adr2?.message) {
            mailErrors[2] = errors.mail_adr2?.message;
        }
        if (errors.mail_adr3?.message) {
            mailErrors[3] = errors.mail_adr3?.message;
        }
        if (errors.mail_adr4?.message) {
            mailErrors[4] = errors.mail_adr4?.message;
        }
        for (let i = 0; i <= mailErrors.length; i++) {
            let errorMessage = mailErrors[i];
            let searchInput = /input/;
            let searchForm = /form/;

            if (searchInput.test(errorMessage)) {
                errorMessage = errorMessage.replace(/input/, "")
                inputErrors.push(errorMessage);
            }
            if (searchForm.test(errorMessage)) {
                errorMessage = errorMessage.replace(/form/, "")
                formErrors.push(errorMessage);
            }
        }
        if (mailErrors.length > 0) {
            let inputErrorsStr = inputErrors.toString();
            let formErrorsStr = formErrors.toString();
            if (inputErrorsStr && formErrorsStr) {
                inputErrorsStr = inputErrorsStr.replaceAll(",", "、");
                formErrorsStr = formErrorsStr.replaceAll(",", "、");
                alert(`${inputErrorsStr}にはメールアドレスを入力してください。\n${formErrorsStr}はメールアドレスの形式が間違っています。`);
                clearErrors();
                return;
            } else {
                if (inputErrorsStr) {
                    inputErrorsStr = inputErrorsStr.replaceAll(",", "、");
                    alert(`${inputErrorsStr}にはメールアドレスを入力してください。`);
                    clearErrors();
                    return;
                } else {
                    formErrorsStr = formErrorsStr.replaceAll(",", "、");
                    alert(`${formErrorsStr}はメールアドレスの形式が間違っています。`);
                    clearErrors();
                    return;
                }
            }
        }
        clearErrors();
    }

    const buttonRegist = () => {
        let newHwList;
        if (hWList.length !== 0) {
            for (let i = 0; i < hWList.length; i++) {
                hWList[i].num = hWList[i].num.trim()
            }
        }
        newHwList = hWList;
        if (emailList.length !== 0) {
            let check = emailList.find((item) =>
                item.emailConfirm !== item.email) ? true : false;
            if (check === true) {
                let emailNum = emailList.find((item) =>
                    item.emailConfirm !== item.email)
                alert(`確認用の回答送付先${emailNum.size + 1}(メールアドレス)が一致していません。`);
                return;
            }
        }

        // 回答送付先にメールアドレスの重複がないかチェック
        let tmp_emailList = emailList.filter((item) => { return item.email.trim() });
        // 固定値のメールアドレスを抽出条件に追加する
        tmp_emailList.push({ "size": emailList.length + 1, "email": mainMail })
        let duplicatedList = emailList.filter((obj_email) =>
            tmp_emailList.find((tmp_email) => (obj_email.email.trim() === tmp_email.email) && (obj_email.size !== tmp_email.size))
        );
        if (duplicatedList.length !== 0) {
            alert("回答送付先のメールアドレスは異なるメールアドレスを指定してください。");
            return;
        }

        if (checkBox === false) {
            alert("マイナンバーの確認にチェックしてください。");
            return;
        }
        var next_state = {
            endUser: endUser ? endUser.trim() : endUser,
            hwNum: hwNum ? hwNum.trim() : hwNum,
            osVer: osVer ? osVer.trim() : osVer,
            operationType: operationType,
            reapearance: reapearance,
            title: title ? title.trim() : title,
            question: question ? question.trim() : question,
            attachedFile: attachedFile,
            dialogValue: dialogValue,
            sWList: sWList,
            sWSize: sWSize,
            hWList: newHwList,
            hWSize: hWSize,
            emailList: emailList,
            emailSize: emailSize,
            mainMail: mainMail,
            softwareNum: softwareNum ? softwareNum.trim() : softwareNum
        };
        navigate("/inquiry_confirm", { state: next_state });
    }

    const goBack = () => {
        initInput();
        navigate("/inquiry_status", { state: { page: true } });
    }
    return (
        <div className="ls-row str-column-main" id="ls-row-3-col-1-row-2-col-2-row-1">
            <div className="str-outer">
                <div className="str-inner">
                    <div className="mod-hdg-l1">
                        <div className="inner">
                            <h1 className="hdg">Web問い合わせシステム</h1>
                            <span className="sub of-top">NEC ファーストコンタクトセンター</span>
                        </div>
                    </div>
                    <h2 className="mod-hdg-l2-02">

                        <span>お問い合わせ(新規)</span>
                    </h2>
                    <div className="mod-txt">
                        <p><em>※Express5800シリーズ/iStorageシリーズ/ビジネスPC製品のお問い合わせに対応しています。</em></p>
                        <p><em>　お問い合わせ対象製品は <a href="/about_contact_center" target="_blank"><img src={imageUrlPopUp} alt="popup" className="icn" lang="en" />ご利用にあたって</a> をご確認ください。</em></p>
                    </div>
                    <Maintenance />
                    <form id="queryForm" name="queryForm">
                        <h4 className="mod-hdg-l4-02">
                            基本情報
                        </h4>

                        <div className="mod-tbl-form">
                            <table role="presentation">
                                <colgroup>
                                    <col className="w-35" />
                                    <col />
                                </colgroup>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b>お客様名(エンドユーザ様名)</b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <input type="text" id="end_user" name="end_user" maxLength="128" style={{ maxWidth: "70%" }}
                                                    placeholder="例：xxxxx会社" value={endUser ? endUser : ""} onChange={handleEndUserChange} />
                                            </div>

                                        </td>
                                    </tr>
                                </tbody>


                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                                                <b><span htmlFor="section">本体(モデル名)<span className="required"
                                                    style={{ top: "14px" }}>必須</span></span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <span><em>該当するものがない場合はその他を選択してください</em></span>
                                            </div>
                                            <div className="mod-input">
                                                <b className="label" style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <span style={{ cursor: "pointer" }} onClick={() => { clearErrors(); setOpenModelDialog({ show: true, dialogId: "hwNameText0" }); }}>
                                                        <img src={imageUrlPopUp} alt="popup" className="icn" lang="en" />
                                                        <span >モデル名を選択してください</span>
                                                    </span>
                                                </b>
                                                <span id="hwNameText0"
                                                    style={buttonStyle}
                                                    onMouseEnter={handleMouseEnter}
                                                    onMouseLeave={handleMouseLeave}
                                                    onClick={() => { clearErrors(); setOpenModelDialog({ show: true, dialogId: "hwNameText0" }); }}
                                                >
                                                    <input type="text" style={{ display: "none" }} id="hw_id" name="hw_id"
                                                        {...register("model",
                                                            {
                                                                required: "本体（モデル名）を選択してください。",
                                                            })} />
                                                    {model}
                                                </span>

                                            </div>
                                            {openModelDialog.show && modelData !== undefined &&
                                                <HardwareDialog
                                                    id={"hwNameText0"}
                                                    open={openModelDialog.show}
                                                    onClose={handleClose}
                                                    value={handleValue("hwNameText0")}
                                                    name={"モデル名を選択してください。"}
                                                    option={modelData}
                                                />}
                                            <input type="hidden" id="hw_name" name="hw_name" className="productName" value="" />

                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">本体型番</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <input type="text" id="hw_num" name="hw_num" maxLength="50" style={{ maxWidth: "50%" }} value={hwNum ? hwNum : ""} onChange={handleHwNumChange} placeholder="例：Nxxxxx" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner" style={{ paddingTop: "10px", paddingBottom: "10px" }}>
                                                <b><span htmlFor="section">OS名<span className="required" style={{ top: "14px" }}>必須</span></span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <span><em>該当するものがない場合はその他を選択してください</em></span>
                                            </div>
                                            <div className="mod-input">
                                                <b className="label" style={{ display: "inline-block", marginRight: "10px" }}>
                                                    <span style={{ cursor: "pointer" }} onClick={() => { clearErrors(); setOpenOsDialog({ show: true, dialogId: "swNameText0" }) }}>
                                                        <img src={imageUrlPopUp} alt="popup" className="icn" lang="en" />
                                                        <span>OS名を選択してください</span>
                                                    </span>
                                                </b>
                                                <span id="swNameText0"
                                                    style={buttonStyle}
                                                    onMouseEnter={handleMouseEnter}
                                                    onMouseLeave={handleMouseLeave}
                                                    onClick={() => { clearErrors(); setOpenOsDialog({ show: true, dialogId: "swNameText0" }) }}
                                                >
                                                    <input type="text" style={{ display: "none" }} id="os_id" name="os_id"
                                                        {...register("os",
                                                            {
                                                                required: "OSを選択してください。",
                                                            })} />
                                                    {os}
                                                </span>
                                                {openOsDialog.show && osData !== undefined &&
                                                    <HardwareDialog
                                                        id={"swNameText0"}
                                                        open={openOsDialog.show}
                                                        onClose={handleClose}
                                                        value={handleValue("swNameText0")}
                                                        name={"OS名を選択してください。"}
                                                        option={osData}
                                                    />}
                                                <input type="hidden" id="os_name" name="sw_name" className="productName" value="" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">OSバージョン</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <input type="text" id="os_ver" name="os_ver" maxLength="50" style={{ maxWidth: "50%" }} value={osVer ? osVer : ""} onChange={handleOsVerChange} placeholder="例：xxxxx" />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">運用形態<span className="required">必須</span></span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input-radio">
                                                <ul className="list">
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="operation_type1" name="operation_type" value="1" checked={operationType === "1"} onChange={handleOperationTypeChange} />
                                                            <span
                                                                className="label">提案・導入前</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="operation_type2" name="operation_type" value="2" checked={operationType === "2"} onChange={handleOperationTypeChange} />
                                                            <span
                                                                className="label">導入・構築</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="operation_type3" name="operation_type" value="3" checked={operationType === "3"} onChange={handleOperationTypeChange} />
                                                            <span
                                                                className="label">運用中</span>
                                                        </label>
                                                    </li>
                                                    <input type="hidden" style={{ display: "none" }}  {...register("operationType", { required: "運用形態を選択してください。" })} />
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">再現性・発生頻度</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input-radio">
                                                <ul className="list">
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="reapearance1" name="reapearance" value="1" checked={reapearance === "1"} onChange={handleReapearanceChange} /><span
                                                                className="label">稀に</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="reapearance2" name="reapearance" value="2" checked={reapearance === "2"} onChange={handleReapearanceChange} /><span
                                                                className="label">頻繁</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="reapearance3" name="reapearance" value="3" checked={reapearance === "3"} onChange={handleReapearanceChange} /><span
                                                                className="label">必ず</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="reapearance4" name="reapearance" value="4" checked={reapearance === "4"} onChange={handleReapearanceChange} /><span
                                                                className="label">未選択</span>
                                                        </label>
                                                    </li>
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h4 className="mod-hdg-l4-02">
                            関連ハードウェア
                        </h4>

                        <div className="mod-txt">
                            <p>お問い合わせ対象のハードウェアを最大2つまで登録可能です。</p>
                        </div>

                        <div className="mod-btn of-no-arrow of-list">
                            <div className="btn">
                                <button id="hardware-add" type="button" onClick={addHw} disabled={hWList.length === 2 ? true : false}>情報を追加</button>
                            </div>

                            <div className="btn">
                                <button id="hardware-del" type="button" onClick={delHw} disabled={hWList.length === 0 ? true : false}>情報を削除</button>
                            </div>
                        </div>

                        <div className="mod-tbl-form">
                            <table role="presentation" id="hardware-tbl">
                                <colgroup>
                                    <col className="w-35" />
                                    <col />
                                </colgroup>
                                {hWList.length !== 0 ?
                                    hWList.map((size, i) => {
                                        return (
                                            <tbody className="tbody" key={i}>
                                                <tr>
                                                    <td className="caption" rowSpan="2">
                                                        <div className="inner">
                                                            <b><span htmlFor="section">ハードウェア名・型番{size.size}</span></b>
                                                        </div></td>
                                                    <td>
                                                        <div className="mod-input">
                                                            <span><em>該当するものがない場合はその他を選択してください</em></span>
                                                        </div>
                                                        <div className="mod-input">
                                                            <b className="label" style={{ display: "inline-block", marginRight: "10px" }}>
                                                                <span style={{ cursor: "pointer" }} id={"onClickPlace" + size.size} onClick={() => { clearErrors(); setOpenHwDialog({ show: true, dialogId: size.size }) }}>
                                                                    <img src={imageUrlPopUp} alt="popup" className="icn" lang="en" />
                                                                    <span >ハードウェア名を選択してください</span>
                                                                </span>
                                                            </b>
                                                            <span id={"hwNameText" + size.size}
                                                                style={buttonStyle}
                                                                onMouseEnter={handleMouseEnter}
                                                                onMouseLeave={handleMouseLeave}
                                                                onClick={() => { clearErrors(); setOpenHwDialog({ show: true, dialogId: size.size }) }}
                                                            >
                                                                {size.size === 1 ? hardware1 : hardware2}
                                                                <input type="hidden" id={"relate_hw_id" + size.size} name={"relate_hw_id" + size.size}
                                                                    {...register(`hwNameText` + size.size,
                                                                        {
                                                                            required: `ハードウェア名・型番${size.size} を選択してください。`,
                                                                        })}
                                                                />
                                                            </span>
                                                            {openHwDialog.show && openHwDialog.dialogId === size.size && hwData !== undefined &&
                                                                <HardwareDialog
                                                                    id={"hwNameText" + size.size}
                                                                    open={openHwDialog.show}
                                                                    onClose={handleClose}
                                                                    value={handleValue("hwNameText" + size.size)}
                                                                    name={"ハードウェア名を選択してください。"}
                                                                    option={hwData}
                                                                />}
                                                            <input type="hidden" id={"relate_hw_name" + size.size} name={"relate_hw_name" + size.size} className="productName" />
                                                        </div></td></tr>
                                                <tr>
                                                    <td><div className="mod-input"><span><b className="label">型番</b><em>ハードウェア名を選択してから型番を入力してください</em></span>
                                                        <input type="text" id={"relate_hwNum" + size.size} name={size.size} maxLength="50" style={{ maxWidth: "50%" }} onChange={handleHardWare} value={size.num ? size.num : ""} placeholder="例：Nxxxxx" />
                                                    </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        )
                                    })
                                    : null
                                }
                            </table>
                        </div>

                        <h4 className="mod-hdg-l4-02">
                            関連ソフトウェア
                        </h4>

                        <div className="mod-txt">
                            <p>お問い合わせ対象のソフトウェアを最大1つまで登録可能です。</p>
                        </div>

                        <div className="mod-btn of-no-arrow of-list">
                            <div className="btn">
                                <button id="software-add" type="button" onClick={addSw} disabled={sWList.length === 1 ? true : false}>情報を追加</button>
                            </div>

                            <div className="btn">
                                <button id="software-del" type="button" onClick={delSw} disabled={sWList.length === 0 ? true : false}>情報を削除</button>
                            </div>
                        </div>

                        <div className="mod-tbl-form">
                            <table role="presentation" id="software-tbl">
                                <colgroup>
                                    <col className="w-35" />
                                    <col />
                                </colgroup>
                                {sWList.length !== 0 ?
                                    sWList.map((size, i) => {
                                        return (
                                            <tbody className="tbody" key={i}>
                                                <tr>
                                                    <td className="caption" rowSpan="2">
                                                        <div className="inner">
                                                            <b><span htmlFor="section">ソフトウェア名・型番{size.size}</span></b>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="mod-input">
                                                            <span><em>該当するものがない場合はその他を選択してください</em></span>
                                                        </div>
                                                        <div className="mod-input">
                                                        <b className="label" style={{ display: "inline-block", marginRight: "10px" }}>
                                                            <span style={{ cursor: "pointer" }} onClick={() => { clearErrors(); setOpenSwDialog({ show: true, dialogId: size.size }) }}>
                                                                <img src={imageUrlPopUp} alt="popup" className="icn" lang="en" style={{ cursor: "pointer" }} />
                                                                <span>ソフトウェア名を選択してください</span>
                                                            </span>
                                                        </b>
                                                        <span id={"swNameText" + size.size}
                                                            style={buttonStyle}
                                                            onMouseEnter={handleMouseEnter}
                                                            onMouseLeave={handleMouseLeave}
                                                            onClick={() => { clearErrors(); setOpenSwDialog({ show: true, dialogId: size.size }) }}
                                                        >
                                                            {valueCheck.includes(software) === false ? software : OTHER_OS}
                                                            <input type="hidden" id={"relate_sw_id" + size.size} name={"relate_sw_id" + size.size}
                                                                {...register(`swNameText` + size.size,
                                                                    {
                                                                        required: `ソフトウェア名・型番${size.size} を選択してください。`,
                                                                    })}
                                                            />
                                                        </span>
                                                        {openSwDialog.show && openSwDialog.dialogId === size.size && swData !== undefined &&
                                                            <HardwareDialog
                                                                id={"swNameText" + size.size}
                                                                open={openSwDialog.show}
                                                                onClose={handleClose}
                                                                value={handleValue("swNameText" + size.size)}
                                                                name={"ソフトウェア名を選択してください。"}
                                                                option={swData}
                                                            />}
                                                        <input type="hidden" id={"relate_sw_name" + size.size} name={"relate_sw_name" + size.size} className="productName" />
                                                    </div>
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="mod-input">
                                                            <b className="label">型番</b>
                                                        </div>
                                                        <div className="mod-input">
                                                            <span><em>ソフトウェア名を選択してから型番を入力してください</em></span>
                                                        </div>
                                                        <div className="mod-input">
                                                            <input type="text" id={"relate_swNum" + size.size} name={"relate_sw_num_" + size.size} maxLength="50" style={{ maxWidth: "50%" }} value={softwareNum ? softwareNum : ""} onChange={handleSoftWare} placeholder="例：Nxxxxx" />
                                                        </div>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        )
                                    })
                                    : null
                                }
                            </table>
                        </div>

                        <h4 className="mod-hdg-l4-02">
                            問い合わせ内容
                        </h4>

                        <div className="mod-tbl-form">
                            <table role="presentation">
                                <colgroup>
                                    <col className="w-35" />
                                    <col />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b>件名<span className="required">必須</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <label>
                                                    <p className="description">お問い合わせの概要をご入力ください。</p>
                                                    <input type="text" id="title" name="title" maxLength="246" style={{ maxWidth: "100%" }}
                                                        {...register("title", {
                                                            required: "件名を入力してください。",
                                                            pattern: {
                                                                value: /.*\S.*/,
                                                                message: "件名を入力してください。"
                                                            }
                                                        })}
                                                        value={title ? title : ""} onChange={handleTitleChange} />
                                                </label>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>

                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b>お問い合わせ内容<span className="required">必須</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <ul className="list">
                                                <li>
                                                    <div className="mod-input">
                                                        <p className="description">お問い合わせの内容をご入力ください。</p>
                                                        <p className="description">件名、及び、お問い合わせの内容について、特定のセキュリティ上のリスクを伴う文字・表現が含まれている場合は次ページの確認画面にてエラーとなる可能性がございます。</p>
                                                        <p className="description">詳細は以下の「注意事項」をご参照ください。</p>
                                                        <div className="description">
                                                            <b className="label" style={{ display: "inline-block", marginRight: "10px" }}>
                                                                <span style={{ cursor: "pointer" }} onClick={() => { setOpenAttentionDialog({ show: true, dialogId: "attention" }); }}>
                                                                    <img src={imageUrlPopUp} alt="popup" className="icn" lang="en" />
                                                                    <span >注意事項</span>
                                                                </span>
                                                            </b>

                                                        </div>
                                                        {openAttentionDialog.show &&
                                                            <AttentionDialog
                                                                open={openAttentionDialog.show}
                                                                onClose={handleClose}
                                                                name={"注意事項"}
                                                            />}
                                                        <textarea style={{ resize: "none" }} wrap="hard" rows="10" id="question" name="question"
                                                            maxLength="1500" value={question ? question : ""} onChange={handleQuestionChange}>
                                                        </textarea>
                                                        <input type="text" style={{ display: "none" }} id="questionTextAria"
                                                            {...register("question", {
                                                                required: "お問い合わせ内容を入力してください。",
                                                                pattern: {
                                                                    value: /.*\S.*/,
                                                                    message: "お問い合わせ内容を入力してください。"
                                                                }
                                                            })}
                                                        />
                                                    </div>
                                                </li>
                                            </ul>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h4 className="mod-hdg-l4-02">
                            添付ファイル
                        </h4>

                        <div className="mod-tbl-form">
                            <table role="presentation">
                                <colgroup>
                                    <col className="w-35" />
                                    <col />
                                </colgroup>
                                <tbody>
                                    <tr>
                                        <td className="caption">
                                            <div className="inner">
                                                <b><span htmlFor="section">添付ファイル有無<span className="required">必須</span></span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input-radio">
                                                <ul className="list">
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="attached_file1" name="attached_file" value="0" checked={attachedFile === "0"} onChange={handleAttachedFileChange} /><span
                                                                className="label">なし</span>
                                                        </label>
                                                    </li>
                                                    <li>
                                                        <label>
                                                            <input type="radio" id="attached_file2" name="attached_file" value="1" checked={attachedFile === "1"} onChange={handleAttachedFileChange} /><span
                                                                className="label">あり</span>
                                                        </label>
                                                    </li>
                                                    <input type="hidden" style={{ display: "none" }}  {...register("attached_file", { required: "添付ファイル有無をチェックしてください。" })} />
                                                </ul>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <h4 className="mod-hdg-l4-02">
                            回答送付先
                        </h4>

                        <div className="mod-txt">
                            <p>お問い合わせの回答送付先を最大5つまで指定可能です。</p>
                            <p><em>登録可能なメールアドレスは質問者の方と同じ会社のドメインとさせていただきます。</em></p>
                            <p><em>上記以外のメールアドレスを入力された場合、回答を送付いたしません。</em></p>
                        </div>

                        <div className="mod-btn of-no-arrow of-list">
                            <div className="btn">
                                <button id="mail-add" type="button" onClick={addEmail} disabled={emailList.length === 4 ? true : false}>送付先を登録</button>
                            </div>

                            <div className="btn">
                                <button id="mail-del" type="button" onClick={delEmail} disabled={emailList.length === 0 ? true : false}>送付先を削除</button>
                            </div>
                        </div>

                        <div className="mod-tbl-form">
                            <table>
                                <colgroup>
                                    <col className="w-35" />
                                    <col />
                                </colgroup>
                                <tbody role="presentation" id="mail-tbl">
                                    <tr>
                                        <td className="caption" rowSpan="2">
                                            <div className="inner">
                                                <b><span htmlFor="section">回答送付先1</span></b>
                                            </div>
                                        </td>
                                        <td>
                                            <div className="mod-input">
                                                <b className="label">回答送付先1のメールアドレスは固定です。</b>
                                                <input type="text" id="mail_adr0" disabled={true} maxLength={256} style={{ maxWidth: "50%" }} value={mainMail} />
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                                {emailList.length !== 0 ?
                                    emailList.map((size, i) => {
                                        return (
                                            <tbody key={i}>
                                                <tr>
                                                    <td className="caption" rowSpan="2">
                                                        <div className="inner">
                                                            <b><label htmlFor="section">回答送付先{size.size + 1}</label></b>
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="mod-input"><b className="label">回答送付先{size.size + 1}にはメールアドレスをご入力ください。</b>
                                                            <input {...register("mail_adr" + size.size, {
                                                                required: `input回答送付先` + (size.size + 1),
                                                                pattern: {
                                                                    value: /^[0-9a-zA-Z!#$%&'*+-/=?^_`{|}~.]+@([0-9a-zA-Z]([0-9a-zA-Z-]*[0-9a-zA-Z])?\.)+[0-9a-zA-Z]([0-9a-zA-Z-]*[0-9a-zA-Z])$/,
                                                                    message: `form回答送付先` + (size.size + 1)
                                                                }
                                                            })}
                                                                type="text" id={"mail_adr" + size.size} placeholder="mailaddress@example.com" name={"mail_adr" + size.size} maxLength={256} style={{ maxWidth: "50%" }} defaultValue={size.email ? size.email : ""} onChange={handleMailChange} />
                                                        </div>
                                                    </td></tr>
                                                <tr><td><div className="mod-input"><b className="label">回答送付先{size.size + 1}（メールアドレス）（確認用）をご入力ください。</b>
                                                    <input type="text" id={"mail_adr_chk_" + size.size} placeholder="mailaddress@example.com" name={"mail_adr_chk_" + size.size} maxLength={256} style={{ maxWidth: "50%" }} value={size.emailConfirm ? size.emailConfirm : ""} onChange={handleMailConfirmChange} />
                                                </div></td></tr>
                                            </tbody>
                                        )
                                    })
                                    : null
                                }
                            </table>
                        </div>

                        <h4 className="mod-hdg-l4-02">
                            マイナンバーの確認
                        </h4>

                        <div className="mod-txt">
                            <p>当センターでは、個人番号(マイナンバー)が含まれない情報の範囲で対応させていただきます。</p>
                            <p><em>恐れ入りますが、お問い合わせ内容および添付資料を再度ご確認いただき、以下をチェックしてください。</em></p>
                        </div>
                        <div className="mod-input-check">
                            <ul className="list">
                                <li><label>
                                    <input type="checkbox" id="mynumber" name="mynumber" checked={checkBox === true} onChange={handleCheckBoxChange} />
                                    <span className="label">お問い合わせ内容および添付資料にマイナンバーは含まれません。</span>
                                </label></li>
                            </ul>

                        </div>

                    </form>
                    <div>
                        <div className="mod-btn of-list">
                            <div className="btn">
                                <button id="btn-go-top" className="of-left" onClick={goBack}>トップページへ</button>
                            </div>
                            <div className="btn">
                                <button type="submit" id="btn-
                            send" className="btn_default_select" onClick={handleSubmit(onSubmit, checkErrorIsExist() === true ? checkErrors(errors) : null)}>登録する</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div >
        </div >
    )
}

export default MainComponent;